export const chatInputResources = {
  "zh-CN": {
    chat: {
      chatInput: {
        common: {
          listSeparator: "、",
        },
        tagScope: {
          label: "按标签限定范围",
          selectedCount: "已选 {{count}}",
        },
        organizeScope: {
          title: "选择要整理的文件夹或文件",
          confirm: "发起整理",
          folderCount_one: "{{count}} 个文件夹",
          folderCount_other: "{{count}} 个文件夹",
          fileCount_one: "{{count}} 个文件",
          fileCount_other: "{{count}} 个文件",
          scopeAssigned: "已设定整理范围：{{scope}}",
          unlimited: "未限定",
        },
        conversationParameters: {
          ariaLabel: "本次信息，已补充 {{count}} 项",
          trigger: "本次信息",
          title: "已提供的信息",
          viewEdit: "查看 / 修改",
        },
        mentionPicker: {
          fileSourceSession: "本会话",
          fileSourceCenter: "文件中心",
          title: "选择文件",
          sessionTab: "本会话",
          fileCenterTab: "文件中心",
          emptySession: "本会话还没有附件",
          centerPickerTitle: "选择文件中心文件",
          referencedFolderCount_one: "已引用 {{count}} 个文件夹",
          referencedFolderCount_other: "已引用 {{count}} 个文件夹",
        },
        skills: {
          maximumSelected: "最多同时挂载 {{count}} 个技能",
          label: "技能",
          selectedCount_one: "技能 {{count}}",
          selectedCount_other: "技能 {{count}}",
          choose: "选择技能",
          selectedAriaLabel_one: "已挂载 {{count}} 个技能",
          selectedAriaLabel_other: "已挂载 {{count}} 个技能",
          selectedAriaLabel: "已挂载 {{count}} 个技能",
          loadFailed: "技能加载失败",
          retry: "重试",
          chooseCurrent: "选择本次使用的技能，最多 {{count}} 个",
          loading: "正在加载技能…",
          empty: "暂无可用技能。请到「智能体工坊 → 技能」创建或共享。",
          packagePreset: "包预置",
          hasFiles: "含文件",
          hasFilesTitle: "该技能包含附件文件，在聊天中不可用（仅智能体运行环境可用）。",
        },
        taskPreparation: {
          ariaLabel: "任务准备",
          researchReport: "生成研究报告",
          businessTask: "执行业务任务",
          assistantName: "智能体：{{name}}",
          addSourcesWithAssistant: "请补充研究资料，联网范围沿用智能体发布配置。",
          addSources: "请添加研究资料，或开启联网搜索。",
          sourceRange: "资料范围：{{sources}}",
          selectFile: "选择文件",
          exit: "退出",
          sourceSummary: {
            conversationAttachments: "对话附件",
            knowledgeBaseCount_one: "{{count}} 个知识库",
            knowledgeBaseCount_other: "{{count}} 个知识库",
            assistantKnowledgeBase: "智能体绑定知识库",
            webSearchDisabled: "未开启联网搜索",
          },
        },
        ability: {
          addMaterials: "添加资料",
          addMaterialsWithCount_one: "添加资料，已选 {{count}} 个知识库",
          addMaterialsWithCount_other: "添加资料，已选 {{count}} 个知识库",
          scopeTitle: "资料范围：{{summary}}",
          knowledgeBaseCount_one: "· {{count}} 个知识库",
          knowledgeBaseCount_other: "· {{count}} 个知识库",
          uploadTitle: "单个附件不超过 20MB。大文件建议先在文件中心解析，需要长期复用时可加入知识库。",
          uploadLocal: "上传本地文件（可多选）",
          pickFile: "从文件中心或当前会话选择",
          assistantScopeHint: "知识范围由智能体已发布配置决定，可补充本次附件。",
          knowledgeBaseHeader: "知识库 · 检索相关内容",
          loadingKnowledgeBases: "正在加载知识库",
          noKnowledgeBases: "暂无可用知识库",
          partialKnowledgeBaseFailure: "部分知识库加载失败，点击重试",
          knowledgeBaseGroups: {
            private: "我的知识库",
            shared: "共享给我",
            public: "公共知识库",
          },
        },
        webSearch: {
          enable: "开启联网搜索",
          disable: "关闭联网搜索",
          label: "联网搜索",
          checkingAvailability: "正在检查联网搜索可用性…",
          loadFailed: "联网搜索状态暂时无法加载。",
          retry: "重试",
          noAuthorizedSources: "暂无获授权的联网搜索来源，请联系管理员。",
          noConfiguredScope: "当前助手未配置联网检索范围，请联系创建者或管理员。",
          sourceUnavailable: "当前联网检索范围暂不可用，请联系管理员检查连接状态。",
        },
        attachment: {
          regionAriaLabel: "本次问答的文件，共 {{count}} 个，可横向滚动查看",
          materializingTitle: "正在读取已同步到文件中心的内容",
          largeFileTitle: "资料较大，建议在文件中心构建后加入知识库。",
          openMaterializedFileTitle: "{{filename}} · 查看文件中心内容",
          materializing: "正在读取文件中心内容…",
          pageCount_one: "{{count}} 页",
          pageCount_other: "{{count}} 页",
          imageCount_one: "{{count}} 张图片",
          imageCount_other: "{{count}} 张图片",
          pendingPageCount: "页数待识别",
          metadataSeparator: " · ",
          exactParseTitle: "重新精确解析，改善复杂版式和表格识别",
          exactParseAriaLabel: "精确解析",
          addVideoToKnowledgeBaseTitle: "将已生成的结构化视频语料加入当前知识库",
          addToKnowledgeBase: "加入知识库",
          remove: "移除附件",
          status: {
            reading: "读取中",
            attachFailed: "读取失败",
            corpusReferenceFailed: "语料引用失败",
            readyTitle: "已解析，模型尚未阅读",
            readyAriaLabel: "已解析，待阅读",
            parsing: "解析中…",
            parseFailed: "解析失败",
            unknownError: "未知错误",
          },
        },
        capabilityStrip: {
          selectedAriaLabel: "已选能力",
          unknownKnowledgeBase: "未知知识库",
          agentKnowledgeBaseTitle: "智能体绑定知识库：{{name}}（自动生效，切换或移除请更换智能体）",
          inaccessibleKnowledgeBase: "该知识库不存在或已无权访问",
          knowledgeBaseTitle: "知识库：{{name}}",
          tagScopeLabel_one: "标签限定 {{count}} 项",
          tagScopeLabel_other: "标签限定 {{count}} 项",
          tagScopeTitle: "检索按受控标签限定范围（在「添加资料」菜单中调整）",
          referenceLabel: "引用：{{names}}",
          folderFallback: "文件夹",
          referenceTitle: "引用的文件夹已作为对话上下文；输入「帮我整理这个文件夹」等指令时，智能体才会执行整理。",
          organizeTitle: "文档整理：智能体将读取范围内的文献并提交整理提案，待你确认。在输入框输入 @ 可调整目录范围。",
          knowledgeStewardLabel: "知识库管家",
          knowledgeStewardTitle: "知识库治理：智能体可列出知识库、检查文档画像、检索内容，并列出待裁决的关系（只读巡检）。",
          skillTitleWithDescription: "技能：{{name}}——{{description}}",
          skillTitle: "技能：{{name}}",
          remove: "移除 {{label}}",
          directoryFallback: "目录",
          organizeRange: "整理范围：{{directories}}{{fileSuffix}}",
          organizeRangeFiles_one: "整理范围：{{count}} 个文件",
          organizeRangeFiles_other: "整理范围：{{count}} 个文件",
          organizeFileSuffix_one: " +{{count}} 个文件",
          organizeFileSuffix_other: " +{{count}} 个文件",
          organizeUnscoped: "文档整理（未限定目录）",
        },
        botDropdown: {
          otherAssistant: "其他助手",
          current: "当前",
          switchCurrent: "切换智能体，当前：{{name}}",
          choose: "选择智能体",
          searchPlaceholder: "搜索智能体名称或用途…",
          searchAriaLabel: "搜索智能体",
          loadFailed: "智能体加载失败，点击重试",
          loading: "正在加载智能体…",
          noMatches: "没有匹配的智能体",
          empty: "暂无智能体",
          containsCurrent: "含当前智能体",
          clearSelection: "清除智能体选择",
        },
      },
    },
  },
  "en-US": {
    chat: {
      chatInput: {
        common: {
          listSeparator: ", ",
        },
        tagScope: {
          label: "Filter by tags",
          selectedCount: "{{count}} selected",
        },
        organizeScope: {
          title: "Choose folders or files to organize",
          confirm: "Start organizing",
          folderCount_one: "{{count}} folder",
          folderCount_other: "{{count}} folders",
          fileCount_one: "{{count}} file",
          fileCount_other: "{{count}} files",
          scopeAssigned: "Organization scope set: {{scope}}",
          unlimited: "unrestricted",
        },
        conversationParameters: {
          ariaLabel: "Information for this turn, {{count}} provided",
          trigger: "This turn",
          title: "Information provided",
          viewEdit: "View / edit",
        },
        mentionPicker: {
          fileSourceSession: "This conversation",
          fileSourceCenter: "File Center",
          title: "Choose a file",
          sessionTab: "This conversation",
          fileCenterTab: "File Center",
          emptySession: "No attachments in this conversation",
          centerPickerTitle: "Choose a File Center file",
          referencedFolderCount_one: "Referenced {{count}} folder",
          referencedFolderCount_other: "Referenced {{count}} folders",
        },
        skills: {
          maximumSelected: "You can attach up to {{count}} skills at a time",
          label: "Skills",
          selectedCount_one: "Skill {{count}}",
          selectedCount_other: "Skills {{count}}",
          selectedAriaLabel_one: "{{count}} skill attached",
          selectedAriaLabel_other: "{{count}} skills attached",
          choose: "Choose skills",
          selectedAriaLabel: "{{count}} skills attached",
          loadFailed: "Could not load skills",
          retry: "Retry",
          chooseCurrent: "Choose skills for this conversation (up to {{count}})",
          loading: "Loading skills…",
          empty: "No skills are available. Create or share one in Agent Workshop → Skills.",
          packagePreset: "Package preset",
          hasFiles: "Has files",
          hasFilesTitle: "This skill includes attachment files. They are unavailable in chat and only work in the Bot runtime.",
        },
        taskPreparation: {
          ariaLabel: "Task preparation",
          researchReport: "Generate a research report",
          businessTask: "Run a business task",
          assistantName: "Agent: {{name}}",
          addSourcesWithAssistant: "Add research sources. Web access follows the agent's published configuration.",
          addSources: "Add research sources or enable web search.",
          sourceRange: "Sources: {{sources}}",
          selectFile: "Choose files",
          exit: "Exit",
          sourceSummary: {
            conversationAttachments: "Conversation attachments",
            knowledgeBaseCount_one: "{{count}} knowledge base",
            knowledgeBaseCount_other: "{{count}} knowledge bases",
            assistantKnowledgeBase: "Agent-bound knowledge base",
            webSearchDisabled: "Web search is off",
          },
        },
        ability: {
          addMaterials: "Add sources",
          addMaterialsWithCount_one: "Add sources, {{count}} knowledge base selected",
          addMaterialsWithCount_other: "Add sources, {{count}} knowledge bases selected",
          scopeTitle: "Sources: {{summary}}",
          knowledgeBaseCount_one: "· {{count}} knowledge base",
          knowledgeBaseCount_other: "· {{count}} knowledge bases",
          uploadTitle: "Each attachment must be 20 MB or smaller. Parse larger files in File Center first, then add them to a knowledge base for reuse.",
          uploadLocal: "Upload local files",
          pickFile: "Choose from File Center or this conversation",
          assistantScopeHint: "The agent's published settings determine the knowledge scope. You can add attachments for this turn.",
          knowledgeBaseHeader: "Knowledge bases · Search relevant content",
          loadingKnowledgeBases: "Loading knowledge bases",
          noKnowledgeBases: "No knowledge bases available",
          partialKnowledgeBaseFailure: "Some knowledge bases could not load. Click to retry.",
          knowledgeBaseGroups: {
            private: "My knowledge bases",
            shared: "Shared with me",
            public: "Public knowledge bases",
          },
        },
        webSearch: {
          enable: "Enable web search",
          disable: "Disable web search",
          label: "Web search",
          checkingAvailability: "Checking web search availability…",
          loadFailed: "Web search status could not be loaded.",
          retry: "Retry",
          noAuthorizedSources: "No authorized web search sources. Contact your administrator.",
          noConfiguredScope: "Web search is not configured for this assistant. Contact its creator or an administrator.",
          sourceUnavailable: "The configured web search scope is unavailable. Ask an administrator to check the connection.",
        },
        attachment: {
          regionAriaLabel: "Files for this conversation, {{count}} total. Scroll horizontally to view.",
          materializingTitle: "Reading content synced to File Center",
          largeFileTitle: "This source is large. Build it in File Center before adding it to a knowledge base.",
          openMaterializedFileTitle: "{{filename}} · View content in File Center",
          materializing: "Reading content from File Center…",
          pageCount_one: "{{count}} page",
          pageCount_other: "{{count}} pages",
          imageCount_one: "{{count}} image",
          imageCount_other: "{{count}} images",
          pendingPageCount: "Pages not identified yet",
          metadataSeparator: " · ",
          exactParseTitle: "Run high-accuracy parsing again to improve complex layouts and table recognition",
          exactParseAriaLabel: "Precise parsing",
          addVideoToKnowledgeBaseTitle: "Add the generated structured video content to the current knowledge base",
          addToKnowledgeBase: "Add to knowledge base",
          remove: "Remove attachment",
          status: {
            reading: "Reading",
            attachFailed: "Read failed",
            corpusReferenceFailed: "Could not reference the content",
            readyTitle: "Parsed; the model has not read it yet",
            readyAriaLabel: "Parsed, waiting to be read",
            parsing: "Parsing…",
            parseFailed: "Parsing failed",
            unknownError: "Unknown error",
          },
        },
        capabilityStrip: {
          selectedAriaLabel: "Selected capabilities",
          unknownKnowledgeBase: "Unknown knowledge base",
          agentKnowledgeBaseTitle: "Agent-bound knowledge base: {{name}} (applied automatically; switch or remove it by choosing another agent)",
          inaccessibleKnowledgeBase: "This knowledge base does not exist or you no longer have access",
          knowledgeBaseTitle: "Knowledge base: {{name}}",
          tagScopeLabel_one: "{{count}} tag filter",
          tagScopeLabel_other: "{{count}} tag filters",
          tagScopeTitle: "Search is limited by controlled tags. Adjust this in the Add sources menu.",
          referenceLabel: "Referenced: {{names}}",
          folderFallback: "Folder",
          referenceTitle: "Referenced folders are included as conversation context. The agent organizes them only when you ask, for example, “Organize this folder.”",
          organizeTitle: "Document organization: The agent reads items in this scope and submits a proposal for your review. Type @ in the input to adjust the folder scope.",
          knowledgeStewardLabel: "Knowledge base steward",
          knowledgeStewardTitle: "KB governance: The agent can list knowledge bases, inspect document profiles, search content, and list relationships awaiting review (read-only).",
          skillTitleWithDescription: "Skill: {{name}} — {{description}}",
          skillTitle: "Skill: {{name}}",
          remove: "Remove {{label}}",
          directoryFallback: "Directory",
          organizeRange: "Organization scope: {{directories}}{{fileSuffix}}",
          organizeRangeFiles_one: "Organization scope: {{count}} file",
          organizeRangeFiles_other: "Organization scope: {{count}} files",
          organizeFileSuffix_one: " +{{count}} file",
          organizeFileSuffix_other: " +{{count}} files",
          organizeUnscoped: "Document organization (no folder scope)",
        },
        botDropdown: {
          otherAssistant: "Other assistants",
          current: "Current",
          switchCurrent: "Switch agent, current: {{name}}",
          choose: "Choose an agent",
          searchPlaceholder: "Search agent names or purposes…",
          searchAriaLabel: "Search agents",
          loadFailed: "Could not load agents. Click to retry.",
          loading: "Loading agents…",
          noMatches: "No matching agents",
          empty: "No agents available",
          containsCurrent: "Contains the current agent",
          clearSelection: "Clear agent selection",
        },
      },
    },
  },
} as const;
